import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/http/api.service';

@Injectable({
  providedIn: 'root',
})
export class OtpSmsService {
  constructor(private http: ApiService) {}

  send(data?, header?) {
    return this.http.post(`/api/sms-otp/send/`, data, header);
  }

  verify(data) {
    return this.http.post(`/api/sms-otp/verify/`, data);
  }

  close(data) {
    return this.http.post(`/api/sms-otp/close/`, data);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ContractOtpSmsService {
  constructor(private http: ApiService) {}

  send(id, header?, data?) {
    return this.http.post(
      `/api/memos/contract/${id}/sms-otp/`,
      data,
      header,
    );
  }
}
